import React from 'react';
import _ from 'lodash';

import { Table } from 'iron-forge-react-modules';
import { BaseWidget } from 'modules';
import * as dataService from './dataService';
import * as types from './types';
import { Chip } from '@mui/material';



const TableComponent = Table.genTableComponent<types.IColumnId>({});



export const FC: React.FC = () => {
  const {
    queryTuple,
    pageInfo,
    fnQueryPage
  } = dataService.useQuery();



  const rows = React.useMemo(
    () => _.map(queryTuple.data.tickets, (ticket): types.IRow => ({
      id: ticket.id,
      columnId2Value: {
        key: {
          type: 'string',
          label: ticket.key
        },
        createdAt: {
          type: 'string',
          label: ticket.createdAt.toFormat('yyyy-MM-dd')
        },
        title: {
          type: 'string',
          label: ticket.title
        },
        status: {
          type: 'component',
          sortableValue: ticket.status,
          label: (
            <Chip
              color={ticket.status === 'inProgress'
                ? 'primary'
                : ticket.status === 'notStarted'
                  ? 'default'
                  : 'success'}
              label={_.startCase(ticket.status)} />
          )
        }
      }
    })),
    [queryTuple.data.tickets]
  );

  return (
    <BaseWidget.FC title="Current Work">
      <TableComponent
        paginationOptions={Table.pageInfo2PaginationOptions(pageInfo, fnQueryPage)}
        rows={rows}
        disableSorting
        columns={[
          {
            id: 'key',
            label: "Key"
          },
          {
            id: 'createdAt',
            label: "Created At"
          },
          {
            id: 'title',
            label: "Title"
          },
          {
            id: 'status',
            label: "Status"
          }
        ]} />
    </BaseWidget.FC>
  );
};
